var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHumanResourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 66.883,
    viewBox: "0 0 218 66.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6887",
    "data-name": "Group 6887",
    transform: "translate(19897 24165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M94.032,163.072a.934.934,0,0,0,1.032-.94,1.032,1.032,0,0,0-2.065,0,.94.94,0,0,0,1.032.94Z",
    transform: "translate(-19987.867 -24290.02)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M99.332,163.072a.934.934,0,0,0,1.032-.94,1.032,1.032,0,0,0-2.065,0,.94.94,0,0,0,1.032.94Z",
    transform: "translate(-19990.432 -24290.02)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M104.032,184.587a.955.955,0,0,0-1.032.934,1.032,1.032,0,1,0,2.065,0,.955.955,0,0,0-1.032-.934Z",
    transform: "translate(-19992.705 -24301.381)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M109.272,184.587a.955.955,0,0,0-1.032.934,1.032,1.032,0,0,0,2.065,0,.95.95,0,0,0-1.032-.934Z",
    transform: "translate(-19995.24 -24301.381)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M106.3,171.257a1.92,1.92,0,0,1,2-2.065,4.81,4.81,0,0,1,2,.516l.516-1.518a6.959,6.959,0,0,0-2.659-.65,3.189,3.189,0,0,0-3.438,3.423,7.408,7.408,0,0,0,.516,2.442h-3.5v-5.761h-1.631v5.771H95.7v-5.771H93.067c-2.53,0-4.2,1.549-4.2,3.717h0a3.659,3.659,0,0,0,3.98,3.686H111.12V173.4h-4.058A4,4,0,0,1,106.3,171.257Zm-12.2,2.158H92.706a2.1,2.1,0,0,1-2.3-2.065h0a2.079,2.079,0,0,1,2.3-2.065H94.1Z",
    transform: "translate(-19985.869 -24293.137)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M159.232,163.722a.934.934,0,0,0,1.032-.94,1.032,1.032,0,0,0-2.065,0,.945.945,0,0,0,1.032.94Z",
    transform: "translate(-20019.41 -24290.334)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M164.512,163.811a.94.94,0,1,0,0-1.874.955.955,0,0,0-1.032.934.945.945,0,0,0,1.032.94Z",
    transform: "translate(-20021.963 -24290.424)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M158.287,164.759a5.818,5.818,0,0,0-2.71.759l.594,1.5a3.5,3.5,0,0,1,2.013-.614c1.982,0,2.364,2.3,3.474,4.3h-8.311v-5.771h-1.631V170.7H147.3v-2c0-2.359-1.451-3.939-3.614-3.939h0c-2.178,0-3.614,1.575-3.614,3.929v-.031c0,1.409-.681,2.039-1.977,2.039h-1.136V161.92H135.33v10.418H138.1a2.774,2.774,0,0,0,2.69-1.2,3.335,3.335,0,0,0,2.927,1.2h20.133V170.7C162.288,170.009,162.257,164.759,158.287,164.759ZM145.67,170.7h-2a1.843,1.843,0,0,1-2-2.024h0a2.026,2.026,0,0,1,2-2.261h0a2.015,2.015,0,0,1,1.988,2.261Z",
    transform: "translate(-20008.346 -24290.418)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M180.816,184.583a.955.955,0,1,0,.718.244A.95.95,0,0,0,180.816,184.583Z",
    transform: "translate(-20029.832 -24301.377)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M111.387,79.486H105.6v1.647h7.418V70.72h-1.631Z",
    transform: "translate(-19948.102 -24199.207)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1.642,
    height: 6.871,
    transform: "translate(-19840.771 -24127.465)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1.631,
    height: 10.412,
    transform: "translate(-19832.955 -24128.486)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M227.32,162.132a1.032,1.032,0,1,0,1.032-1.032A1.032,1.032,0,0,0,227.32,162.132Z",
    transform: "translate(-20052.848 -24290.02)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M232.6,162.132a1.032,1.032,0,1,0,1.032-1.032A1.032,1.032,0,0,0,232.6,162.132Z",
    transform: "translate(-20055.402 -24290.02)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M238.272,184.587a.955.955,0,0,0-1.032.934,1.032,1.032,0,1,0,2.065,0,.955.955,0,0,0-1.032-.934Z",
    transform: "translate(-20057.646 -24301.381)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M243.562,184.587a.955.955,0,0,0-1.032.934,1.032,1.032,0,0,0,2.065,0,.95.95,0,0,0-1.032-.934Z",
    transform: "translate(-20060.205 -24301.381)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M271.855,163.655a.94.94,0,0,0,1.033-.95,1.032,1.032,0,1,0-1.033.95Z",
    transform: "translate(-20073.895 -24290.258)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M282.472,161.937a.955.955,0,0,0-1.032.934,1.032,1.032,0,1,0,2.065,0,.955.955,0,0,0-1.032-.934Z",
    transform: "translate(-20079.029 -24290.424)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M287,162.871a1.032,1.032,0,1,0,1.033-.934.955.955,0,0,0-1.033.934Z",
    transform: "translate(-20081.715 -24290.424)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M263.261,170.706h-3.423v-5.771h-1.631v5.771h-4.945v-5.771H251.63v5.771h-4.646v-2c0-2.359-1.451-3.939-3.614-3.939h0c-2.179,0-3.614,1.575-3.614,3.929v-.031c0,1.409-.676,2.039-1.972,2.039h-1.662v-5.771h-1.688v5.771h-4.409v-5.771h-2.669c-2.53,0-4.2,1.549-4.2,3.717h0a3.659,3.659,0,0,0,3.98,3.686h10.588a2.774,2.774,0,0,0,2.69-1.2,3.335,3.335,0,0,0,2.927,1.2h21.548v-10.4h-1.631Zm-34.882,0H227a2.1,2.1,0,0,1-2.3-2.065h0a2.082,2.082,0,0,1,2.3-2.065h1.383Zm16.953,0h-2a1.843,1.843,0,0,1-2-2.024h0a2.026,2.026,0,0,1,2-2.261h0a2.016,2.016,0,0,1,1.993,2.261Z",
    transform: "translate(-20050.834 -24290.428)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 1.631,
    height: 10.412,
    transform: "translate(-19783.826 -24128.486)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M318.142,167.74c-2.53,0-4.2,1.549-4.2,3.717h0a3.659,3.659,0,0,0,3.98,3.686h1.244c-.041.9-.671,1.182-1.549,1.182a7.148,7.148,0,0,1-2.153-.346l.33,1.735a6.946,6.946,0,0,0,1.889.253c2.091,0,3.144-.769,3.144-3.247V167.74Zm1.033,3.67h0v2.1h-1.384a2.1,2.1,0,0,1-2.3-2.065h0a2.082,2.082,0,0,1,2.3-2.065h1.384Z",
    transform: "translate(-20094.752 -24293.232)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M248.881,139.307c0-2.349-1.079-3.557-3.479-3.557h-1.141v1.631h1.373c1.131,0,1.709.578,1.709,1.771v2.369H242.81v1.642h6.071Z",
    transform: "translate(-20060.342 -24277.758)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M258.871,142.869V135.75h-1.647v7.387c0,1.032-.475,1.373-1.167,1.373-.336,0-.614-.026-1.033-.062l-.155,1.425a4.516,4.516,0,0,0,1.033.114C257.652,145.987,258.871,145.3,258.871,142.869Z",
    transform: "translate(-20066.176 -24277.758)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 1.631,
    height: 10.412,
    transform: "translate(-19805.41 -24145.002)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M276.158,140.381H277.4c-.036.9-.666,1.182-1.549,1.182a7.156,7.156,0,0,1-2.158-.346l.336,1.735a4.693,4.693,0,0,0,1.549.253c1.962,0,3.335-.676,3.448-2.824h3.495a2.635,2.635,0,0,0,2.535-1.192,3.324,3.324,0,0,0,2.927,1.2h8.657V130h-1.631v8.776h-3.4v-2c0-2.359-1.451-3.939-3.614-3.939h0c-2.178,0-3.614,1.549-3.614,3.929v-.031c0,1.409-.681,2.065-1.977,2.065h-3.319v-5.833h-2.669c-2.53,0-4.2,1.549-4.2,3.717h0C272.178,138.864,273.783,140.381,276.158,140.381Zm9.808-3.676a2.024,2.024,0,0,1,2-2.261h0a2.015,2.015,0,0,1,1.988,2.261v2.034h-2a1.838,1.838,0,0,1-2-2.024Zm-12.25,0a2.079,2.079,0,0,1,2.3-2.065H277.4v2.065h0v2.1h-1.368a2.1,2.1,0,0,1-2.3-2.065Z",
    transform: "translate(-20074.568 -24274.975)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 1.631,
    height: 10.412,
    transform: "translate(-19775.809 -24145.002)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M152.842,131.087a.934.934,0,0,0,1.032-.934,1.032,1.032,0,1,0-2.065,0,.939.939,0,0,0,1.032.934Z",
    transform: "translate(-20016.318 -24274.549)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M147.562,131.087a.934.934,0,0,0,1.032-.934,1.032,1.032,0,1,0-2.065,0,.94.94,0,0,0,1.032.934Z",
    transform: "translate(-20013.764 -24274.549)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M146.33,143.163h8.926V135.75h-1.631v5.771h-4.409V135.75h-2.664c-2.53,0-4.2,1.549-4.2,3.717h0A3.661,3.661,0,0,0,146.33,143.163Zm-2.426-3.7a2.082,2.082,0,0,1,2.3-2.065h1.383v4.13H146.2A2.1,2.1,0,0,1,143.9,139.467Z",
    transform: "translate(-20011.742 -24277.758)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M194.65,129.48a.867.867,0,0,0,.955-.867.96.96,0,1,0-.955.867Z",
    transform: "translate(-20036.578 -24273.795)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M192.076,133.57a.914.914,0,1,0-.693-.241A.909.909,0,0,0,192.076,133.57Z",
    transform: "translate(-20035.32 -24275.824)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M196.206,132.655a.991.991,0,1,0,.991-.9.909.909,0,0,0-.991.9Z",
    transform: "translate(-20037.793 -24275.822)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M199.745,130h-1.631v8.776h-3.2v-5.808h-1.631v5.771h-4.409v-5.771h-1.631v5.771h-3.428V134h-1.642v4.739H179.2V134h-1.631v4.739h-4.207v-5.926h-1.642v7.542c0,1.032-.475,1.373-1.167,1.373-.336,0-.619-.026-1.032-.062l-.15,1.425a4.5,4.5,0,0,0,1.032.114c1.667,0,2.886-.64,2.963-2.824h26.4Z",
    transform: "translate(-20024.813 -24274.975)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 1.631,
    height: 10.412,
    transform: "translate(-19822.951 -24145.002)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M158.3,153.452a1.032,1.032,0,1,0-1.032,1.032A1.032,1.032,0,0,0,158.3,153.452Z",
    transform: "translate(-20018.461 -24285.822)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M163.585,153.452a1.032,1.032,0,1,0-1.032,1.032A1.032,1.032,0,0,0,163.585,153.452Z",
    transform: "translate(-20021.016 -24285.822)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M210.408,152.627a.96.96,0,0,0-1.032.934,1.032,1.032,0,1,0,1.032-.934Z",
    transform: "translate(-20044.164 -24285.92)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M401.119,108.5c.341.046.681.108,1.032.165A53.863,53.863,0,0,1,407.6,100.5,58.649,58.649,0,0,0,390.33,91.21ZM429,130.423l-17.784-5.766L432.1,158.093a57.818,57.818,0,0,0-3.113-27.67Z",
    transform: "translate(-20131.707 -24256.211)",
    fill: "#158285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M399.38,117.548c7.7-12.328,17.743-21.326,32.265-26.328l-20.892,33.442L389.861,158.1C387.992,142.843,391.678,129.876,399.38,117.548Z",
    transform: "translate(-20131.248 -24256.215)",
    fill: "#f7941d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M350.4,126.646l22.224,7.227a79.871,79.871,0,0,1,7.253-3.547q.48-1.177,1.032-2.354c.6-1.316,1.254-2.581,1.931-3.83A67.322,67.322,0,0,0,350.4,126.646Zm60.766,7.227-19.271,6.262,41.495,13.484a67.073,67.073,0,0,0-22.224-19.756Z",
    transform: "translate(-20112.389 -24271.688)",
    fill: "#2bb574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M350.4,153.61l23.716-7.707a64.377,64.377,0,0,1,2.973-6.8,56.709,56.709,0,0,1,2.788-8.776A68.482,68.482,0,0,0,350.4,153.61Zm51.587-29.632-10.092,16.158,41.495-13.479a67.209,67.209,0,0,0-31.4-2.679Z",
    transform: "translate(-20112.389 -24271.689)",
    fill: "#fcb614"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHumanResourse);
export default __webpack_public_path__ + "static/media/logoHumanResourse.96dd80c42918c66189db4c7bee2793bd.svg";
export { ForwardRef as ReactComponent };